import axios from 'axios';
class ImageUploadService {
  constructor() {}

  toBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
  upload(data) {
    return axios.post(
      `https://api.cloudinary.com/v1_1/loops-inc/image/upload?upload_preset=sgg1nhwy`,
      { file: data }
    );
  }
}

export default new ImageUploadService();
